import SpotlightLogo from './spotlight-logo';

export * from './spotlight-logo';
export default SpotlightLogo;
